import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react'
import { Alert, Dropdown, DropdownButton, Form } from 'react-bootstrap';
import { ButtonSpinner } from '../../../../../../../components/ButtonSpinner/ButtonSpinner';
import { InputText } from '../../../../../../../components/Inputs';
import { useForm } from '../../../../../../../hooks/useForm';
import { useLang } from '../../../../../../../language';
import { faSave, faSync } from '@fortawesome/free-solid-svg-icons';
import { SeccionDatosGenerales } from '../SeccionDatosGenerales';
import { SeccionDatosFacturacion } from '../SeccionDatosFacturacion';
import { SeccionOtrosDatos } from '../SeccionOtrosDatos';
import { useValidator } from '../../../../../../../hooks/useValidator';
import { ModalConfirm } from '../../../../../../../components/Modals/ModalConfirm';
import { useModalData } from '../../../../../../../hooks/useModalData';
import { EstadosAlquilerServices } from '../../../../../../../services/statics.service';
import { convertStaticServiceToArray } from '../../../../../../../services/helpers';
import { ModalStatusServer } from '../../../../../../../components/Modals/ModalStatusServer';
import { AlquilerServices } from '../../services/alquileres.service';
import { isStatusSucess } from '../../../../../../../helpers/helpers';
import { InputChecks } from '../../../../../../../components/Inputs/InputChecks';
import { cloneDeep } from 'lodash';
import { ModalGenerarFactura } from '../ModalGenerarFactura';
import { CondicionPagosServices } from '../../../../../../facturacion/pages/Parametros/services/condicionpago.service';
import { CobroServices } from '../../../../../../facturacion/pages/Cobros/services/cobros.service';
import { ModalFechasCalendario } from '../ModalFechasCalendario';

export const DatosGenerales = ({ idpedido, handleFetchSuccess, formInscripcion, handleFormInscripcion,
    handleInputInscripcion, fetchPedidoGET, setcurrentTarifa, currentTarifa }: any) => {

    // let params = useParams();

    const Lang = useLang()

    // Fecha de vencimiento
    const date = new Date()
    date.setDate(date.getDate() + 30)
    const dateFormat = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + date.getDate()).slice(-2)}`

    const [formCobro, handleInputChangeCobro, handleFormChangeCobro, resetformCobro] = useForm({
        fechacobro: '',
        estado: 'P',
        fechavencimiento: dateFormat,
        comunicar: [],
    });

    const [dataModal_GenerarFactura, handleShowModal_GenerarFactura, handleCloseModal_GenerarFactura] = useModalData()

    const [dataModal_Calendario, handleShowModal_Calendario, handleCloseModal_Calendario] = useModalData()


    // const id: string = String(params.id) || ''

    // const nuevo = id === 'nuevo'

    const [formValuesPlantilla, handleInputChangePlantilla, handleFormChangePlantilla, resetFormValuesPlantilla] = useForm(
        {}
    )


    const [formEstado, handleInputEstado, handleFormEstado, resetFormEstado] = useForm({
        comunicar: [],
    })

    const BreadcrumbLineItems = [
        {
            title: Lang('ALQUILER'),
            link: '/alquiler-aparatos-admin/alquileres'
        },
        {
            title: `${formValuesPlantilla.descripcion}`,
            link: `/${idpedido}`
        }
    ]

    // -------- Formulario principal

    const [valuesValidationPersona, handleValidationPersona, handleResetValidationPersona] = useValidator({
        idpersona: { isOk: true, msgError: [`La persona es obligatoria.`] },
    })

    const [valuesValidationEntidad, handleValidationEntidad, handleResetValidationEntidad] = useValidator({
        idpersonaentidad: { isOk: true, msgError: [`La entidad es obligatoria.`] },
    })


    const [valuesValidationStep2, handleValidationStep2, handleResetValidationStep2] = useValidator({
        idcondicionpago: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
        ideventotarifa: { isOk: true, msgError: [Lang('ALERT_OBLIGATORIO_GENERICO')] },
    })

    const staticEstadosAlquiler: any = EstadosAlquilerServices.GET()

    const [dataModal_CambiarEstado, handleShowModal_CambiarEstado, handleCloseModal_CambiarEstado] = useModalData()

    const [fetchCambiarEstadoPedidoPATCH, fetchCambiarEstadoPedidoPATCHData, resetfetchCambiarEstadoPedidoPATCH]
        = AlquilerServices.PATCH_CAMBIAR_ESTADO(idpedido)

    const handleSubmitCambiarPedido = () => {

        fetchCambiarEstadoPedidoPATCH({
            body: {
                estado: dataModal_CambiarEstado.id,
                comunicar: formEstado.comunicar.length === 0
            }
        })
    }

    useEffect(() => {

        if (isStatusSucess(fetchCambiarEstadoPedidoPATCHData.status)) {

            fetchPedidoGET()
            handleCloseModal_CambiarEstado()
        }

    }, [fetchCambiarEstadoPedidoPATCHData]);


    const [fetchPedidoPATCH, fetchPedidoPATCHData, resetfetchPedidoPATCH] = AlquilerServices.PATCH(idpedido)

    const handleSubmitEditarInscripcion = () => {

        fetchPedidoPATCH({
            body: {
                ...formInscripcion,
                inputtotalimportebase: currentTarifa.totalimportebase,
                inputtotalimporteiva: (currentTarifa.importeiva / 100 * Number(currentTarifa.totalimportebase)).toFixed(2),
                idiva: currentTarifa.idiva,
            }
        })
    }

    useEffect(() => {

        if (idpedido && isStatusSucess(fetchPedidoPATCHData.status)) {

            // handleFetchSuccess()
            window.location.reload()
        }

    }, [fetchPedidoPATCHData]);



    const [fetchPedidoGenerarPOST, fetchPedidoGenerarPOSTData, resetfetchPedidoGenerarPOST] = AlquilerServices.POST_GENERAR_FACTURA()

    const handleSubmitPedidoGenerar = () => {

        fetchPedidoGenerarPOST({
            body: formInscripcion
        })
    }


    // Funciones helpers

    const handleChangeCheck = (e: any, name: string) => {

        let listaModulosTemp = cloneDeep(formEstado[name])

        if (e.target.checked) {

            listaModulosTemp.push(e.target.name)

        } else {

            listaModulosTemp = listaModulosTemp.filter((item: any) => item !== e.target.name)
        }

        handleFormEstado({
            ...formEstado,
            [name]: listaModulosTemp
        })
    }

    const [fetchCondicionPagosGET, fetchCondicionPagosGETData] = CondicionPagosServices.GET()

    useEffect(() => {

        fetchCondicionPagosGET({
            params: {
                limit: 200
            }
        })

    }, [])

    const [fetchCobroPATCH, fetchCobroPATCHData] = CobroServices.PATCH_CAMBIAR_ESTADO()

    const handleActualizatCobro = (idCobro: any) => {

        fetchCobroPATCH({
            id: idCobro + '/actualizar',
            body: formCobro
        })

    }

    useEffect(() => {

        if (isStatusSucess(fetchPedidoGenerarPOSTData.status)) {

            const idCobro = fetchPedidoGenerarPOSTData?.data?.data?.facturas?.[0]?.cobros?.[0]?.idcobro || ''

            handleActualizatCobro(idCobro)

            handleCloseModal_GenerarFactura()
        }

    }, [fetchPedidoGenerarPOSTData]);


    useEffect(() => {

        if (isStatusSucess(fetchCobroPATCHData.status)) {

            window.location.href = process.env.PUBLIC_URL + '/alquiler-aparatos-admin/alquileres/' + idpedido + '/facturas';
        }

    }, [fetchCobroPATCHData]);

    const [changeTarifaFlag, setchangeTarifaFlag] = useState(false);

    const handleUpdateDates = (fechadesde: any, fechahasta: any) => {

        if (fechadesde && fechahasta) {

            setchangeTarifaFlag(true)

            handleFormInscripcion({
                ...formInscripcion,
                fechadesde,
                fechahasta,
            })

            handleCloseModal_Calendario()
        }
    }

    return (
        <>

            <div className='d-flex justify-content-between align-items-center'>

                <div className="d-flex align-items-center">
                    <h5 className="mb-3 mb-lg-0 ">{Lang('DATOS_ALQUILER')}</h5>
                    <Alert variant='info' className='my-0 py-1 px-2 ms-2'>
                        {staticEstadosAlquiler[formInscripcion?.estado] || ''}
                    </Alert>
                </div>
                <DropdownButton
                    align="end"
                    variant='outline-primary'
                    title={<span className="me-1">{Lang('CAMBIAR_ESTADO')}</span>}
                    id="dropdown-menu-align-end"
                    className='ms-auto'
                >
                    {
                        convertStaticServiceToArray(staticEstadosAlquiler)?.map((item: any) => {
                            return (
                                <Dropdown.Item onClick={() => handleShowModal_CambiarEstado({ id: item.id })}>{item.nombre}</Dropdown.Item>
                            )
                        })
                    }
                </DropdownButton>
            </div>


            <div className="py-3 px-4 card mt-3 mb-5">

                <div className="row">

                    <SeccionDatosGenerales
                        formInscripcion={formInscripcion}
                        valuesValidationPersona={valuesValidationPersona}
                        handleFormInscripcion={handleFormInscripcion}
                        handleInputInscripcion={handleInputInscripcion}
                        idpedido={idpedido}
                    />

                    <div className="col-12 py-2"></div>

                    <Form.Group className="mb-3 col-12 col-sm-6 col-md-4">
                        <InputText
                            label={`${Lang('FECHA_DESDE')}:`}
                            type='date'
                            name='fechadesde'
                            value={formInscripcion.fechadesde}
                            onChange={handleInputInscripcion}
                            readonly={true}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-12 col-sm-6 col-md-4">
                        <InputText
                            label={`${Lang('FECHA_HASTA')}:`}
                            type='date'
                            name='fechahasta'
                            value={formInscripcion.fechahasta}
                            onChange={handleInputInscripcion}
                            readonly={true}
                        />
                    </Form.Group>

                    <div className="col mb-3 d-flex align-items-end">
                        {
                            idpedido &&
                            <ModalFechasCalendario
                                handleShow={handleShowModal_Calendario}
                                handleClose={handleCloseModal_Calendario}
                                data={dataModal_Calendario}
                                idpedido={idpedido}
                                idproducto={formInscripcion.idproducto}
                                handleUpdateDates={handleUpdateDates}
                            />
                        }
                    </div>

                    <div className="col-12"></div>

                    <SeccionDatosFacturacion
                        formInscripcion={formInscripcion}
                        valuesValidationPersona={valuesValidationPersona}
                        handleFormInscripcion={handleFormInscripcion}
                        handleInputInscripcion={handleInputInscripcion}
                        valuesValidationStep2={valuesValidationStep2}
                        // fetchTarifasGETData={fetchTarifasGETData}
                        idpedido={idpedido}
                        importetotal={formInscripcion.importetotal}
                        currentTarifa={currentTarifa}
                        setcurrentTarifa={setcurrentTarifa}
                        setchangeTarifaFlag={setchangeTarifaFlag}
                        changeTarifaFlag={changeTarifaFlag}
                    />

                    <SeccionOtrosDatos
                        formInscripcion={formInscripcion}
                        valuesValidationPersona={valuesValidationPersona}
                        handleFormInscripcion={handleFormInscripcion}
                        handleInputInscripcion={handleInputInscripcion}
                        idpedido={idpedido}
                    />

                </div>

                <div className="d-flex justify-content-between border-top pt-3 flex-wrap mt-3">

                    {
                        (formInscripcion.facturado) ?

                            <p className='mb-0'>{Lang('P_GUARDAR_NO_GENERAR')}</p>
                            :
                            <ButtonSpinner
                                variant="outline-secondary" type="button" className="me-auto"
                                handleSubmit={handleShowModal_GenerarFactura}
                                value={Lang('GENERAR_FACTURA')} icon={<FontAwesomeIcon icon={faSync} className='me-1' />}
                            />
                    }


                    <ButtonSpinner
                        variant="secondary" type="submit" className="ms-auto"
                        handleSubmit={handleSubmitEditarInscripcion} fetchDataLoading={[fetchPedidoPATCHData.loading]}
                        value={Lang('GUARDAR')} icon={<FontAwesomeIcon icon={faSave} />}
                    />
                </div>

            </div>
            <ModalConfirm
                handleClose={handleCloseModal_CambiarEstado}
                show={dataModal_CambiarEstado.value}
                onClickOK={handleSubmitCambiarPedido}
                messageHTML={
                    <>
                        <h5 className='text-center fw-normal fs-115 mb-4 pb-2'>{Lang('PARRAFO_SEGURO_CAMBIAR_ESTADO_A')}: {staticEstadosAlquiler[dataModal_CambiarEstado.id]}?</h5>

                        <Form.Group className="mb-0 col-12">
                            <div className="row justify-content-center">
                                <InputChecks
                                    name='comunicar'
                                    value={formEstado.comunicar}
                                    values={[{ id: 'comunicar', nombre: Lang('NO_COMUNICAR') }]}
                                    // classNameContainer='col-12 col-lg-6 col-xl-4 mb-3'
                                    onChange={(e: any) => handleChangeCheck(e, 'comunicar')}
                                    // fetchData={nuevo ? fetchPersonaPOSTData : fetchPerfilesPATCHData}
                                    classNameContainer="d-inline-block me-4 w-auto"
                                />

                            </div>
                        </Form.Group>

                    </>
                }
                textOnClickOk={Lang('SI_CAMBIAR_ESTADO')}
                fetchData={fetchCambiarEstadoPedidoPATCHData}
                disableBtnClose
            />

            <ModalStatusServer fetchData={fetchPedidoGenerarPOSTData} />

            <ModalStatusServer fetchData={fetchCambiarEstadoPedidoPATCHData} />

            <ModalStatusServer fetchData={fetchPedidoPATCHData} />

            <ModalGenerarFactura
                data={dataModal_GenerarFactura}
                handleClose={handleCloseModal_GenerarFactura}
                handleSubmitPedidoGenerar={handleSubmitPedidoGenerar}
                fetchPedidoGenerarPOSTData={fetchPedidoGenerarPOSTData}
                currentTarifa={currentTarifa}
                formInscripcion={formInscripcion}
                handleFormInscripcion={handleFormInscripcion}
                idpedido={idpedido}
                fetchCondicionPagosGETData={fetchCondicionPagosGETData}
                handleInputChangeCobro={handleInputChangeCobro}
                resetformCobro={resetformCobro}
                formCobro={formCobro}
            />



        </>
    )
}
